import Vue from 'vue';

import { Component, Prop } from 'vue-property-decorator';
import template from './orderStatusColors.vue';
@Component({
    mixins: [template],
})
export default class OrderStatusColors extends Vue {
    @Prop()
    status: string;

    @Prop({ default: '' })
    form: string;

    @Prop({ default: false })
    isCapital: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/components/orderStatusColors/index.ts